const cloudIdLookupQuery = `
query tenantQuery($cloudIds: [ID!]) {
  tenantContexts(cloudIds: $cloudIds) {
    cloudUrl
  }
}
`;

type TenantResponse = {
	data?: {
		tenantContexts?: Array<{ cloudUrl: string }>;
	};
};

export const getCloudUrlFromId = async (cloudId: string) => {
	const response = await fetch('/gateway/api/graphql', {
		headers: {
			'Content-Type': 'application/json',
		},
		method: 'POST',
		body: JSON.stringify({
			query: cloudIdLookupQuery,
			variables: {
				cloudIds: [cloudId],
			},
		}),
	});

	const json: TenantResponse = await response.json();
	return json.data?.tenantContexts?.[0];
};
